<template>
  <div class="page-account">
    <div class="page-account-content">
      <div class="content-top">
        <h1 class="content-header">财务系统（服务商）</h1>
        <div class="content-desc">Finance Management System</div>
      </div>
      <div class="content-main">
        <div class="content-title">
          <i class="el-icon-back" @click="toLogin"></i>
          <h3 class="title">忘记密码</h3>
        </div>
        <el-form
          ref="form"
          :model="form"
          label-width="0"
          status-icon
          :rules="rules"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号码"
              maxlength="11"
              readonly
              onfocus="this.removeAttribute('readonly')"
            >
              <i slot="prefix" class="el-input__icon el-icon-my-phone" />
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="flex flex-justify-between">
              <el-input
                v-model="form.code"
                maxlength="8"
                placeholder="请输入验证码"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly')"
              >
                <i slot="prefix" class="el-input__icon el-icon-my-code" />
                <el-button
                  slot="append"
                  @click="getCode"
                  :disabled="disabled"
                  type="primary"
                  style="min-width: 96px;padding: 12px;"
                >{{btnText}}</el-button>
              </el-input>
            </div>

          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="form.password"
              placeholder="请输入新密码"
              readonly
              onfocus="this.removeAttribute('readonly')"
            >
              <i slot="prefix" class="el-input__icon el-icon-my-pwd" />
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSubmit" :loading="loading" style="width: 100%;">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="page-account-footer">
      <div class="footer-copyright">{{ copyright }}</div>
    </div>
  </div>
</template>

<script>
import { validateMobile, validatePwd } from '@/utils/validate-rules';
import { COPYRIGHT } from '@/config';
// eslint-disable-next-line import/no-cycle
import { resetPwd, queryCode } from '@/api/account';
import { isMobile } from '@/utils/validate';

export default {
  name: 'ForgotPwd',
  data() {
    return {
      copyright: COPYRIGHT,
      rules: {
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { validate: validateMobile, min: 11, message: '手机号码格式不对', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: validatePwd, min: 6, trigger: 'blur' },
        ],
      },
      form: {
        phone: '',
        password: '',
        code: '',
      },
      loading: false,
      btnText: '获取验证码',
      disabled: false,
      count: 60,
      timer: null,
    };
  },
  methods: {
    async getCode() {
      if (!isMobile(this.form.phone)) {
        this.$message.warning('手机号码格式不对');
        return;
      }
      try {
        this.setTimer();
        await queryCode({
          phone: this.form.phone,
          type: 1,
          fromClient: 'service-provider-client', // 信息模版固定参数
        });
      } catch (error) {
        clearInterval(this.timer);
        this.btnText = '获取验证码';
        this.disabled = false;
        console.log(error);
      }
    },
    setTimer() {
      let num = 60;
      this.btnText = `${num}S`;
      this.timer = setInterval(() => {
        num -= 1;
        this.btnText = `${num}S`;
        this.disabled = true;
        if (num === 0) {
          this.btnText = '获取验证码';
          this.disabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 返回
    toLogin() {
      this.$router.replace({
        name: 'Login',
      });
      clearInterval(this.timer);
    },
    // 确认
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            await resetPwd(this.form);
            this.$message.success('更改密码成功');
            this.toLogin();
            this.loading = false;
            clearInterval(this.timer);
          } catch (error) {
            console.error(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./account.scss";

::v-deep {
  .el-input-group__append {
    background-color: #FFA040;
    border-color: #FFA040;
    color: #fff;
  }
  .el-button--primary.is-disabled:hover{
    background-color: #FFA040;
    border-color: #FFA040;
  }
}

.forget{
  text-align: right;
  color:#888;
  span{
    cursor: pointer;
  }
}

.content-title{
  position: relative;
  .el-icon-back{
    position: absolute;
    top:50%;
    font-size: 20px;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .title{
    text-align: center;
    font-size: 18px !important;
  }
}

.el-icon-my-code{
  background: url("../../assets/image/icon-code.png") center no-repeat;
}
.el-icon-my-phone{
  background: url("../../assets/image/icon-phone.png") center no-repeat;
}
.el-icon-my-pwd{
  background: url("../../assets/image/icon-pwd.png") center no-repeat;
}

</style>
